// N by N matrices are represented as arrays of N^2 elements, going row by row.

// Multiply a 2 by 2 matrix by a 2-vector to get a new 2-vector.
const multiplyMV2 = function(m, v) {
	return [m[0] * v[0] + m[1] * v[1], m[2] * v[0] + m[3] * v[1]];
};

// Multiply a 4 by 4 matrix by a 4-vector to get a new 4-vector.
const multiplyMV4 = function(m, v) {
	return [
		m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
		m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
		m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
		m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3],
	];
};

// Multiply two 4 by 4 matrices to get a new 4 by 4 matrix.
const multiplyMM4 = function(m1, m2) {
	return [
		m1[0] * m2[0] + m1[1] * m2[4] + m1[2] * m2[8] + m1[3] * m2[12],
		m1[0] * m2[1] + m1[1] * m2[5] + m1[2] * m2[9] + m1[3] * m2[13],
		m1[0] * m2[2] + m1[1] * m2[6] + m1[2] * m2[10] + m1[3] * m2[14],
		m1[0] * m2[3] + m1[1] * m2[7] + m1[2] * m2[11] + m1[3] * m2[15],
		m1[4] * m2[0] + m1[5] * m2[4] + m1[6] * m2[8] + m1[7] * m2[12],
		m1[4] * m2[1] + m1[5] * m2[5] + m1[6] * m2[9] + m1[7] * m2[13],
		m1[4] * m2[2] + m1[5] * m2[6] + m1[6] * m2[10] + m1[7] * m2[14],
		m1[4] * m2[3] + m1[5] * m2[7] + m1[6] * m2[11] + m1[7] * m2[15],
		m1[8] * m2[0] + m1[9] * m2[4] + m1[10] * m2[8] + m1[11] * m2[12],
		m1[8] * m2[1] + m1[9] * m2[5] + m1[10] * m2[9] + m1[11] * m2[13],
		m1[8] * m2[2] + m1[9] * m2[6] + m1[10] * m2[10] + m1[11] * m2[14],
		m1[8] * m2[3] + m1[9] * m2[7] + m1[10] * m2[11] + m1[11] * m2[15],
		m1[12] * m2[0] + m1[13] * m2[4] + m1[14] * m2[8] + m1[15] * m2[12],
		m1[12] * m2[1] + m1[13] * m2[5] + m1[14] * m2[9] + m1[15] * m2[13],
		m1[12] * m2[2] + m1[13] * m2[6] + m1[14] * m2[10] + m1[15] * m2[14],
		m1[12] * m2[3] + m1[13] * m2[7] + m1[14] * m2[11] + m1[15] * m2[15],
	];
};

const invertM2 = function(m) {
	const det = m[0] * m[3] - m[1] * m[2];
	return [m[3] / det, -m[1] / det, -m[2] / det, m[0] / det];
};

module.exports = {
	multiplyMV2,
	multiplyMV4,
	multiplyMM4,
	invertM2,
};
